import React from 'react';
//assets
import NotificationBlueIcon from 'assets/icons/notificationBlueIcon.svg';
//query
import { useUpdateNotificationsMutation } from 'redux/services/notifications';
//utils
import { formatTimeDifferenceUTC } from 'constants/updatedAt';
import { EventEnums, NotificationTypeMap } from './constant';
//hooks
import { useNavigate } from 'react-router-dom';
//component
import { Switch } from '@/components/mira';
import { Button } from '@/components/mira';
import Loader from 'wrapper/loader';
import styles from './notification.module.css';

const NotificationTab = ({
  notifications,
  isFetching,
  showUnread,
  setShowUnread,
  setNotification,
}) => {
  const navigateTo = useNavigate();

  // rtk query
  const [updateNotification] = useUpdateNotificationsMutation();

  // redirect to pages based on notification type
  const handleClick = async (
    typeId,
    application_id,
    userNotificationId,
    isRead
  ) => {
    if (isRead === '0') {
      await updateNotification({
        data: { notification_ids: [userNotificationId] },
      });
    }
    const eventType = NotificationTypeMap[typeId];
    if (eventType) {
      switch (eventType) {
        case EventEnums.CONSUMER_PROFILE_ID_CREATED:
          navigateTo('/profile');
          break;
        case EventEnums.CONSUMER_PROFILE_COMPLETED:
          navigateTo('/pipeline');
          break;
        case EventEnums.CONSUMER_ELIGIBLE:
          navigateTo('/pipeline');
          break;
        case EventEnums.CONSUMER_PRE_APPROVED:
          navigateTo('/pipeline');
          break;
        case EventEnums.CONSUMER_NOT_ELIGIBLE:
          navigateTo('/profile');
          break;
        case EventEnums.CONSUMER_PRE_APPROVAL_REJECTION:
          navigateTo('/profile');
          break;
        case EventEnums.CONSUMER_QUOTE:
          break;
        case EventEnums.CONSUMER_EMAIL_CHANGE_VERIFICATION:
          break;
        case EventEnums.LOAN_OFFICER_CONSUMER_COMPLETED_ONBOARDING:
          navigateTo(`/loanInformation/lead?applicationId=${application_id}`);
          break;
        case EventEnums.LOAN_OFFICER_PROFILE_COMPLETED:
          navigateTo(`/loanInformation/lead?applicationId=${application_id}`);
          break;
        case EventEnums.LOAN_OFFICER_ADD_LEAD:
          navigateTo(`/loanInformation/lead?applicationId=${application_id}`);
          break;
        case EventEnums.LOAN_OFFICER_ELIGIBLE:
          navigateTo(`/loanInformation/lead?applicationId=${application_id}`);
          break;
        case EventEnums.LOAN_OFFICER_PRE_APPROVED:
          navigateTo(`/pipeline/lead?applicationId=${application_id}`);
          break;
        case EventEnums.LOAN_OFFICER_PRE_APPROVAL_REJECTION:
          navigateTo(`/pipeline/lead?applicationId=${application_id}`);
          break;
        case EventEnums.LOAN_OFFICER_NOT_ELIGIBLE:
          navigateTo(`/loanInformation/lead?applicationId=${application_id}`);
          break;
        default:
          console.error(`Unknown notification type: ${eventType}`);
          break;
      }
    } else {
      console.error(`Unknown notification type ID: ${typeId}`);
    }
    setNotification(false);
  };

  // Update the state based on the toggle state
  const handleToggle = (e) => {
    const nextValue = typeof e === 'boolean' ? e : Boolean(e?.target?.checked);
    setShowUnread(nextValue);
  };

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <h3 className={styles.title}>Notifications</h3>
        <button
          type="button"
          className={styles.closeButton}
          onClick={() => setNotification(false)}
          aria-label="Close notifications"
        >
          ×
        </button>
      </div>

      <div className={styles.controls}>
        <div className={styles.unreadToggle}>
          <span>Show only unread</span>
          <Switch checked={showUnread} onCheckedChange={handleToggle} />
        </div>
      </div>

      <div className={styles.listArea}>
        {isFetching && <Loader />}
        {!isFetching && notifications?.length === 0 && (
          <div className={styles.emptyState}>
            <img src={NotificationBlueIcon} alt="" aria-hidden="true" className={styles.emptyIcon} />
            <h4 className={styles.emptyTitle}>You have no new notifications at this time.</h4>
            <p className={styles.emptyHint}>
              You'll be notified here when something relevant happens.
            </p>
          </div>
        )}
        {!isFetching &&
          notifications?.length > 0 &&
          notifications?.map((item) => {
            return (
              <div
                className={styles.notificationItem}
                key={item.userNotificationId}
                onClick={() =>
                  handleClick(
                    item.typeId,
                    item.applicationId,
                    item.userNotificationId,
                    item.isRead
                  )
                }
              >
                <div className={styles.notificationHeader}>
                  <div className={styles.subjectWrap}>
                    <span className={styles.subject}>
                      {item.subject}
                    </span>
                    {item.isRead === '0' && (
                      <div className={styles.unreadDot} />
                    )}
                  </div>
                  <span className={styles.time}>{formatTimeDifferenceUTC(item?.createdAt)}</span>
                </div>
                <p className={styles.message}>
                  {item.message}
                </p>
                {item?.isRead === '0' && (
                  <Button
                    variant="primary_sm"
                    type="button"
                    btnClassName="!py-1.5 px-2"
                    onClick={() =>
                      handleClick(
                        item.typeId,
                        item.applicationId,
                        item.userNotificationId,
                        item.isRead
                      )
                    }
                  >
                    <div className={styles.reviewLabel}>Review</div>
                  </Button>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default NotificationTab;
